import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "./globals.css";
import ScrollToTop from "./components/ScrollToTop";
import { routes } from "./routes";

import TelegramFeedWithNotify from "./components/TelegramFeed";
// import XLiveFeedWithNotify from "./components/XLiveFeedWithNotify";

function App() {
  return (
    <Router>
      <ScrollToTop />

      {/* Routes rendering */}
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        {routes.map(({ path, element }, index) => (
          <Route key={index} path={path} element={element} />
        ))}
      </Routes>

      {/* Fixed notification buttons (bottom-left corner) */}
      <div className="fixed bottom-4 left-4 z-50 flex gap-2">
        <TelegramFeedWithNotify />
        {/* <XLiveFeedWithNotify /> */}
      </div>
    </Router>
  );
}

export default App;
